export default {
  heading: 'Open Sans, serif',
  body: 'Lora, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Playball, cursive',
  googleFonts: ['Open Sans:100,200,300,400,500,600,700,800,900', 'Lora:400,500,600,700,800,900', 'Playball']
  // customFamilies: [''],
  // customUrls: [''],
}
